
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.174 12.83a.462.462 0 00.225.532l1.609.92a2 2 0 001.984 0l1.516-.867a2 2 0 011.984 0l1.516.866a2 2 0 001.984 0l1.516-.866a2 2 0 011.984 0l1.516.866a2 2 0 001.984 0l1.609-.919a.462.462 0 00.225-.532A4.002 4.002 0 0018 10H6a4.002 4.002 0 00-3.826 2.83zM22 16.3a.5.5 0 00-.748-.435l-.267.153a4 4 0 01-3.97 0l-1.515-.866-1.515.866a4 4 0 01-3.97 0L8.5 15.152l-1.515.866a4 4 0 01-3.97 0l-.267-.153a.5.5 0 00-.748.434V20a2 2 0 002 2h16a2 2 0 002-2v-3.7z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 7a1 1 0 011 1v2a1 1 0 11-2 0V8a1 1 0 011-1zM10.737 3.605a1.53 1.53 0 002.458 1.821v-.001c.21-.262.335-.594.335-.955 0-.321-.098-.62-.267-.865a1.555 1.555 0 00-.067-.09l-.001-.002v-.001l-.065-.086a40.918 40.918 0 00-.878-1.129.323.323 0 00-.504 0 54.565 54.565 0 00-.879 1.13l-.063.084v.002c-.024.03-.047.06-.068.09v.002zm1.307.83l.045.035-.045-.034z"}})])
          )
        }
      }
    